import { render, staticRenderFns } from "./Plandetail.vue?vue&type=template&id=523dc6a4&scoped=true"
import script from "./Plandetail.vue?vue&type=script&lang=js"
export * from "./Plandetail.vue?vue&type=script&lang=js"
import style1 from "./Plandetail.vue?vue&type=style&index=1&id=523dc6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dc6a4",
  null
  
)

export default component.exports